import { ISideMenuAllLang, SIDE_MENU_ALL_LANG_KEY } from './sideMenu'
import { IOfferAllLang, OFFER_ALL_LANG_KEY } from './offer'
import { IOfferScopeAllLang, OFFER_SCOPE_ALL_LANG_KEY } from './offerScope'
import { IEnumAllLang, ENUM_ALL_LANG_KEY } from './enum'
import { IOfferSpendAllLang, OFFER_SPEND_ALL_LANG_KEY } from './offerSpend'
import { IGeneralAllLang, GENERAL_ALL_LANG_KEY } from './general'
import { ILoginAllLang, LOGIN_ALL_LANG_KEY } from './login'
import { IPostbackSendAllLang, POSTBACK_SEND_ALL_LANG_KEY } from './postbackSend'
import { IRevenueAgencyAllLang, REVENUE_AGENCY_ALL_LANG_KEY } from './revenueAgency'
import { IRevenueSpendAllLang, REVENUE_SPEND_ALL_LANG_KEY } from './revenueSpend'
import { IAccountAllLang, ACCOUNT_ALL_LANG_KEY } from './account'
import { IRoleAllLang, ROLE_ALL_LANG_KEY } from './role'
import { IAffiliateAllLang, AFFILIATE_ALL_LANG_KEY } from './affiliate'

export * from './general'
export * from './enum'
export * from './login'
export * from './sideMenu'
export * from './affiliate'
export * from './offer'
export * from './offerScope'
export * from './offerSpend'
export * from './postbackSend'
export * from './revenueAgency'
export * from './revenueSpend'
export * from './account'
export * from './role'

// TODO: add/check types for all langs
export type IAllLang =
	& IGeneralAllLang
	& IEnumAllLang
	& ILoginAllLang
	& ISideMenuAllLang
	& IAffiliateAllLang
	& IOfferAllLang
	& IOfferScopeAllLang
	& IOfferSpendAllLang
	& IPostbackSendAllLang
	& IRevenueAgencyAllLang
	& IRevenueSpendAllLang
	& IAccountAllLang
	& IRoleAllLang


//TODO: add/check constant for all langs
export const ALL_LANG_KEY: IAllLang = {
	...GENERAL_ALL_LANG_KEY,
	...ENUM_ALL_LANG_KEY,
	...LOGIN_ALL_LANG_KEY,
	...SIDE_MENU_ALL_LANG_KEY,
	...AFFILIATE_ALL_LANG_KEY,
	...OFFER_ALL_LANG_KEY,
	...OFFER_SCOPE_ALL_LANG_KEY,
	...OFFER_SPEND_ALL_LANG_KEY,
	...POSTBACK_SEND_ALL_LANG_KEY,
	...REVENUE_AGENCY_ALL_LANG_KEY,
	...REVENUE_SPEND_ALL_LANG_KEY,
	...ACCOUNT_ALL_LANG_KEY,
	...ROLE_ALL_LANG_KEY
}

console.log('----------------------', { ALL_LANG_KEY })